import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableHeadCell,
  TableCell,
  Typography,
  Paginator,
} from '@safedns/skydns-ui-react-lib';

import LocalDomainTableRow from './LocalDomainTableRow';
import DeleteLocalDomain from './DeleteLocalDomain';
import SearchInput from '../UI/search/SearchInput';

import { useGetUserQuery, useGetLocalDomainsQuery } from '../../services/ADapi';
import usePagination from '../../hooks/usePagination';
import { setSearchQuery } from '../../store/localDomainsReducer';
import { actionTableCellStyle } from '../../styles/tableStyles';

const filterLocalDomains = (localDomains, searchQuery) => {
  const lowerCaseSearchQuery = searchQuery.toLowerCase();

  if (localDomains) {
    return localDomains.filter(({ domain }) => {
      return domain.toLowerCase().includes(lowerCaseSearchQuery);
    });
  }

  return [];
};

const LocalDomainsTable = () => {
  const { searchQuery } = useSelector((state) => state.localDomains);
  const {
    data: { user_id },
  } = useGetUserQuery();

  const { data, isLoading } = useGetLocalDomainsQuery(user_id);

  const localDomains = filterLocalDomains(data, searchQuery);

  const ITEMS_PER_PAGE = 10;
  const {
    firstContentIndex,
    lastContentIndex,
    page,
    gaps,
    totalPages,
    nextPage,
    prevPage,
    setPage,
  } = usePagination({
    contentPerPage: ITEMS_PER_PAGE,
    count: localDomains.length,
  });

  useEffect(() => {
    if (searchQuery.length > 0) {
      setPage(0);
    }
  }, [searchQuery, setPage]);

  if (isLoading) {
    return <Typography variant="subtitle2">Загрузка...</Typography>;
  }

  return (
    <>
      <SearchInput
        placeholder="Найти домен"
        cb={setSearchQuery}
        sx={{ maxWidth: 460 }}
      />
      <TableContainer sx={{ paddingTop: 24 }}>
        <Table sx={{ minWidth: '650px' }}>
          <TableHead>
            <TableRow>
              <TableHeadCell sx={{ textAlign: 'left' }}>
                Локальный домен
              </TableHeadCell>
              <TableHeadCell sx={{ textAlign: 'left' }}>
                Домен контроллер
              </TableHeadCell>
              <TableHeadCell sx={actionTableCellStyle}></TableHeadCell>
              <TableHeadCell sx={actionTableCellStyle}></TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {localDomains.length === 0 ? (
              <TableRow>
                <TableCell colSpan="2">
                  <Typography variant="subtitle2">
                    Нет локальных доменов, соответствующих заданному фильтру.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              localDomains
                .slice(firstContentIndex, lastContentIndex)
                .map(({ id, controller_ids, domain }) => (
                  <LocalDomainTableRow
                    key={`${id}-local-domain`}
                    id={id}
                    name={domain}
                    controllerIds={controller_ids}
                  />
                ))
            )}
          </TableBody>
        </Table>
        <DeleteLocalDomain />
      </TableContainer>
      {localDomains.length > ITEMS_PER_PAGE ? (
        <Paginator
          nextPage={nextPage}
          prevPage={prevPage}
          page={page}
          gaps={gaps}
          setPage={setPage}
          totalPages={totalPages}
        />
      ) : null}
    </>
  );
};

export default LocalDomainsTable;
